import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import type { ButtonProps } from '@mui/material';

type SparkButtonProps = ButtonProps & {
  isLoading?: boolean;
};

function SparkButton({ ...ButtonProps }: SparkButtonProps) {
  const { sx, children, isLoading, ...rest } = ButtonProps;

  return (
    <Button
      disabled={isLoading}
      sx={{
        fontWeigh: 700,
        fontFamily: 'Mont-SemiBold',
        fontSize: 16,
        lineHeight: '20.45px',
        borderColor: (theme) =>
          rest.variant === 'outlined'
            ? theme.palette.borderColor
            : 'transparent',
        '& span': {
          marginTop: '-1px',
        },

        ...sx,
      }}
      {...rest}
    >
      {isLoading ? (
        <CircularProgress size={20} sx={{ color: 'white' }} />
      ) : (
        <>{children}</>
      )}
    </Button>
  );
}

export default SparkButton;
